module.exports = __webpack_public_path__ + "static/media/scarf.e5f930bb.svg";